import { useTranslation } from "react-i18next";
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { MdOutlinePending } from 'react-icons/md';

type TaxesMessageProps = {
  taxActivated: boolean;
  taxEnabled: boolean;
};

function TaxesMessage({ taxActivated, taxEnabled }: TaxesMessageProps) {
  const { t } = useTranslation();


  return (
    <div
      className={`flex flex-col items-center gap-4 rounded-md p-6 text-base font-semibold sm:flex-row ${
        taxActivated && taxEnabled
          ? 'bg-green-400 text-green-900' // Green if both activated & enabled
          : 'bg-yellow-400 text-yellow-900' // Yellow otherwise
      }`}
    >
      {taxActivated && taxEnabled ? (
        // Case 1: Tax is ACTIVATED and ENABLED
        <>
          <AiOutlineCheckCircle className="flex-shrink-0 text-2xl" />
          <span className="text-center sm:text-start">
            {t("taxesMessage.active")}
          </span>
        </>
      ) : taxEnabled && !taxActivated ? (
        // Case 2: Tax is ENABLED but NOT ACTIVATED
        <>
          <MdOutlinePending className="flex-shrink-0 text-2xl" />
          <span className="text-center sm:text-start">
          {t("taxesMessage.inactiveIncluded")}
          </span>
        </>
      ) : !taxEnabled && !taxActivated ? (
        // Case 3: Tax is NOT ENABLED AND NOT ACTIVATED
        <>
        <MdOutlinePending className="flex-shrink-0 text-2xl" />
        <span className="text-center sm:text-start">
        {t("taxesMessage.inactiveWillAdd")}
        </span>
      </>
      ) : null}
    </div>
  );
}

export default TaxesMessage;